import React from 'react';
import { FixedSizeList } from 'react-window';

const renderRow = (props) => {
  const { data, index, style } = props;
  return React.cloneElement(data[index], { style });
};
const VirtualizedListbox = React.forwardRef((props, ref) => {
  const itemData = React.Children.toArray(props.children);
  const itemCount = itemData.length;
  const itemSize = 36;
  const itemsToShow = Math.min(10, itemCount);
  const height = Math.max(itemSize, itemsToShow * itemSize - 0.5 * itemSize);
  return /* @__PURE__ */ React.createElement("div", { ref }, /* @__PURE__ */ React.createElement(
    FixedSizeList,
    {
      height,
      itemData,
      itemCount,
      itemSize,
      width: "100%"
    },
    renderRow
  ));
});

export { VirtualizedListbox };
//# sourceMappingURL=VirtualizedListbox.esm.js.map
